import { styled } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import TitlePart from '../atoms/TitlePart';
import EmptyState from '../molecules/Emptystate';
import empty from '../../assets/empty.svg';
import SingleLineText from '../atoms/SingleLineText';

export type TalentSectionContainerProps = {
  title: string;
  emptyText: string;
  addActionFn?: () => void;
  addActionText?: string;
  children?: React.ReactNode;
};

const TalentSectionContainer = ({
  title,
  emptyText,
  addActionFn,
  addActionText,
  children,
}: TalentSectionContainerProps) => {
  return (
    <SectionContainer>
      <HeaderContainer>
        <TitlePart variant="heading6" textTitle={title} />
        {addActionFn && (
          <StyledRowContainerAdd onClick={addActionFn}>
            <AddIcon />
            <SingleLineText variant={'body2Medium'} text={addActionText} />
          </StyledRowContainerAdd>
        )}
      </HeaderContainer>
      <ContentContainer>
        {children}
        {!children && (
          <EmptyStateContainer>
            <EmptyState image={empty} text={emptyText} />
          </EmptyStateContainer>
        )}
      </ContentContainer>
    </SectionContainer>
  );
};

export default TalentSectionContainer;

const SectionContainer = styled('div')(({ theme }) => ({
  boxShadow: '0px 4.30769px 23.6923px rgba(75, 75, 75, 0.09)',
  borderRadius: '10px',
  textAlign: 'left',
  padding: '24px 24px 32px 24px',
  marginBottom: '24px',
  backgroundColor: theme.palette.neutral.white,
}));

const HeaderContainer = styled('div')(() => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const StyledRowContainerAdd = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-end;
    text-decoration: underline;
    color: ${theme.palette.neutral[80]};
    float: right;
  
    &:hover {
      cursor: pointer;
    }
    `,
);

const ContentContainer = styled('div')(() => ({
  paddingTop: '16px',
}));

const EmptyStateContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
}));
